import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @fileoverview Heart — Loci saved-state icon
 *
 * Lucide-derived heart icon with a 1.8px stroke. Purely presentational; callers
 * supply interactivity (buttons, toggles, aria-labels). Defaults to 20px white
 * to match the Loci design spec for inline use on event cards and the saved
 * screen.
 */
import { forwardRef } from 'react';
import { Heart as LucideHeart } from 'lucide-react';
/**
 * Heart — saved-state icon from the Loci design system.
 *
 * Decorative by default (`aria-hidden="true"`); the parent control is
 * responsible for accessible labelling.
 */
export const Heart = forwardRef(({ filled = false, color = '#FFFFFF', size = 20, className }, ref) => {
    return (_jsx(LucideHeart, { ref: ref, size: size, strokeWidth: 1.8, stroke: color, fill: filled ? color : 'none', className: className, "aria-hidden": "true" }));
});
Heart.displayName = 'Heart';
